import IndustryBenefitsI18n from "@/components/landing/shared/IndustryBenefitsI18n";
import { TrendingUp, Heart, PiggyBank, Users } from "lucide-react";
const VorteileEinzelhandelSection = () => <IndustryBenefitsI18n translationPrefix="industryEinzelhandel" icons={[TrendingUp, Heart, PiggyBank, Users]} />;
export default VorteileEinzelhandelSection;
